import { baseAPIRequest } from 'utilities/http';

import { baseURI } from './config';

async function postUpDownVote (id, voteType) {

	try {

		const url = `${baseURI}/reviews/${id}/${voteType}`;

		const response = await baseAPIRequest({
			url,
			params: { method: 'POST' }
		});
		if (!response.isSuccess) {

			const [ error ] = response.errors;
			throw new Error(`Failed to post review vote: ${error.message}`);

		}
		return response;

	} catch (error) {

		// eslint-disable-next-line no-console
		console.error(error.message);
		throw Error;

	}

}

export default postUpDownVote;
